<template>
  <div class="header-wrapper page-leaderboard animate fadeIn">
    <h1 class="page-title">ยอดบริจาค</h1>
    <div class="container-leaderboard">
      <ul class="tab">
        <li class="tab-page"><a :class="{active: activeTab === 'page'}" href="#" @click.prevent="switchTab('page')"><span class="icon _sl-page">&nbsp;</span>กองผ้าป่า</a></li>
        <li class="tab-school"><a :class="{active: activeTab === 'school'}" href="#" @click.prevent="switchTab('school')"><span class="icon _sl-school">&nbsp;</span>โรงเรียน</a></li>
        <li class="tab-province"><a :class="{active: activeTab === 'province'}" href="#" @click.prevent="switchTab('province')"><span class="icon _sl-province">&nbsp;</span>จังหวัด</a></li>
      </ul>

      <transition name="fade">
        <product-leaderboard v-show="activeTab === 'page'"
                             :link="true"
                             :searchable="true"
                             ref="page" />
      </transition>

      <transition name="fade">
        <product-leaderboard v-show="activeTab === 'school'"
                             type="categories"
                             title-field="name"
                             :params="{with_total:true,vocab:'school'}"
                             :ipp="100"
                             :load-on-start="false"
                             ref="school" />
      </transition>

      <transition name="fade">
        <product-leaderboard v-show="activeTab === 'province'"
                             type="categories"
                             title-field="name"
                             :params="{with_total:true,vocab:'province'}"
                             :load-on-start="false"
                             :ipp="100"
                             ref="province" />
      </transition>
    </div>
  </div>
</template>

<script>
  import Loader from '@/components/Loader'
  import ProductLeaderboard from '@/components/ProductLeaderboard'

  export default {
    name: 'ProductLeaderboardPage',

    components: {
      Loader,
      ProductLeaderboard
    },

    data () {
      return {
        product: null,
        activeTab: 'page'
      }
    },

    created () {
      this.getProduct()
    },

    methods: {
      getProduct () {
        const sku = this.$route.params.sku
        this.$http.get(`products/${sku}`)
          .then(resp => {
            this.product = resp.body
          })
          .catch(err => {
            console.log(err)
          })
      },

      switchTab (tab) {
        if (this.activeTab !== tab) {
          this.activeTab = tab
          this.$refs[tab].init()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
.page-leaderboard {
  .page-title {
    text-align: center;
    font-size: 2em;
    font-weight: 400;
    color: #3F4041;
    margin-bottom: 0;
  }
  .container-leaderboard {
    max-width: 650px;
    background: #fff;
    border: 1px solid #979797;
    margin: 1em auto 1em;
  }
  .tab {
    overflow: hidden;
    border-bottom: 1px solid #979797;
    list-style: none;
    padding: 0;
    margin: 0 0 1em;
    > li {
      float: left;
      width: calc(100%/3);
      margin: 0;

      a {
        display: block;
        font-weight: 400;
        font-size: 1.2em;
        color: #F6931D;
        text-align: center;
        line-height: 2.5em;
        border-right: 1px solid #ccc;
        &:last-child { border-right: 0; }
        &.active, &:hover {
          background: #4E4E4E;
          text-decoration: none;
          color: #fff;
        }
      }
    }
  }
}
.icon {
  display: inline-block;
  padding-left: 22px;
  background: url("../assets/img/icon/ic-page-sm@2x.png") no-repeat left center;
  &._sl-province {background: url("../assets/img/icon/ic-province-sm@2x.png") no-repeat left center; background-size: 14px; }
  &._sl-school {background: url("../assets/img/icon/ic-school-sm@2x.png") no-repeat left center; background-size: 13px;}
  &._sl-page {background: url("../assets/img/icon/ic-page-sm@2x.png") no-repeat left center; background-size: 19px;}
}

@media (max-width: 375px) {
  .icon {
    padding-left: 20px;
  }
  .tab > li a {font-size: 17px !important; }
}
</style>



// WEBPACK FOOTER //
// ProductLeaderboardPage.vue?40e2a2ab